module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "tip-label": _vm.tipLabel,
      "bar-color": _vm.barColor
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Batsmen: By Individual Scores")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 batsmen with highest individual score in an\n      IPL match across all seasons.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Chris Gayle of Royal Challengers Banglore leads the chart with a massive\n        score of 175 runs, scored against Pune Warriors.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        CH Gayle has 3 entries in top 10, followed by AB de Villiers and Virender Sehwag,\n        both at 2 entries.\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-120edf4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/BatsmenIndividualScores.vue
// module id = 391
// module chunks = 1